/**
 * Join Intelligence Layout Components
 *
 * 统一的布局组件系统，用于替换项目中重复的容器和区块模式
 */

export { default as JContainer } from './JContainer';
export { default as JSection } from './JSection';
